import Footer from "./Footer";
import Header from "./Header";
import translatedHeading from "../utils/util";
import "../styles/App.css";


const Gallery = () =>{
    return(
        <>
        <Header />
        <div className="page-header">{translatedHeading("Gallery")}</div>
        <div className="gallery">
            <h3>Under development</h3>
        </div>
        <Footer/>
        </>
    )
}
export default Gallery;